import util from '@bmp-vue/core/api/util'

const controller = 'ImportaArquivos'
export default Object.assign({}, util.GetCrud(controller, null), {
  Post: function (dto) {
    return util.Axios.PostForm(controller, dto)
  },
  Alerta: function (file) {
    console.log(file)
  },
  PostCNAB: function (dto) {
    return util.Axios.PostForm(controller + '/PostImportaArquivoCNAB', dto)
  },
})
